import type { LucideIcon } from "lucide-react";
import { renderIcon } from "@/components/tailwind/editor/renderIcon";
import { getPropertyIcon } from "./propertyTypes";

interface PropertyIconProps {
  /** Custom property icon (emoji or Iconify id); falls back to the type icon when empty. */
  icon?: string;
  type: string;
  className?: string;
  size?: number;
  /** Icon to render when the type has no canonical icon (e.g. "title"). */
  fallback?: LucideIcon;
}

export function PropertyIcon({ icon, type, className, size = 16, fallback }: PropertyIconProps) {
  if (icon) {
    return <>{renderIcon(icon, { className, style: { width: size, height: size } })}</>;
  }
  const TypeIcon = getPropertyIcon(type) ?? fallback;
  return TypeIcon ? <TypeIcon className={className} style={{ width: size, height: size }} /> : null;
}
